import { ReactNode } from 'react';

import { Column } from '../Column/Column';
import { InfoBoxContent, InfoBoxTitle } from './style';

export interface InfoBoxProps {
	title?: string;
	children?: ReactNode;
}

export function InfoBox({ children, title }: InfoBoxProps) {
	return (
		<Column $gap={4}>
			{title && <InfoBoxTitle>{ title }</InfoBoxTitle>}
			<InfoBoxContent>{children}</InfoBoxContent>
		</Column>
	);
}
